export const PROFILE_LOADING  = "PROFILE_LOADING";
export const PROFILE_SET_DATA  = "PROFILE_SET_DATA";
export const PROFILE_SET_DATA_ERROR = "PROFILE_SET_DATA_ERROR";
export const PROFILE_EDIT_START= "PROFILE_EDIT_START";
export const PROFILE_EDIT_SUCCESS= "PROFILE_EDIT_SUCCESS";
export const PROFILE_EDIT_FAILURE= "PROFILE_EDIT_FAILURE";
export const GET_OTHER_PROFILE_START= "GET_OTHER_PROFILE_START";
export const GET_OTHER_PROFILE_SUCCESS= "GET_OTHER_PROFILE_SUCCESS";
export const GET_OTHER_PROFILE_FAILURE= "GET_OTHER_PROFILE_FAILURE";